function currentUser () {
  return window.currentUser
}

function normalizeCurrentUser (user) {
  return user?.data || user || null
}

function currentUserFromPageProps (pageProps) {
  return normalizeCurrentUser(pageProps?.current_user) || normalizeCurrentUser(pageProps?.auth?.user)
}

function syncCurrentUser (pageProps) {
  const user = currentUserFromPageProps(pageProps)

  if (user) {
    window.currentUser = user
  } else {
    delete window.currentUser
  }

  return user
}

function can (permission) {
  const permissions = currentUser()?.permissions || []
  return permissions.includes(permission)
}

export default {
  methods: {
    $can: can,
  },
}

export {
  currentUser,
  currentUserFromPageProps,
  can,
  syncCurrentUser,
}
